import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  FormGroup,
} from "reactstrap";
import "./CommonForm.scss";
import Button from "../../../Components/Buttons/Button";
import Authentication from "../../../Components/Popup/Authentication";
import FormUI from "../../../Components/Popup/FormUI";
import { getCategoryWiseSubcategory } from "../../../services/getCategoryWiseSubcategory";
import { getSubcategoryWisePrice } from "../../../services/getSubcategoryWisePrice";
import { createQuestionHomeworkHelp } from "../../../services/createQuestionHomeworkHelp";
import { updateHomeworkHelpQuestion } from "../../../services/updateHomeworkHelpQuestion";
import { useLocation, useNavigate } from "react-router-dom";
import { updateAssignmentQuestion } from "../../../services/updateAssignmentQuestion";
import { createQuestionAssignmentHelp } from "../../../services/createQuestionAssignmentHelp";
import { getPriceLivehelp } from "../../../services/getPriceLivehelp";
import { updateLiveSessionQuestion } from "../../../services/updateLiveSessionQuestion";
import { createQuestionLivesessionHelp } from "../../../services/createQuestionLivesessionHelp";
import { getCategories } from "../../../services/getCategories";
import { ImageLink } from "../../../constants";
import checkLogo from "../../../Assets/images/Group 707.svg";
import SubmitButton from "../../../Components/Buttons/SubmitButton";
import { FiAlertTriangle } from "react-icons/fi";
import { useSubSubjects } from "../../../context/SubSubjectsContext";
const categoryStatic = [
  {
    label: "Homework Help",
    sublabel: "Ask your doubts here",
    serviceType: "HomeworkHelp",
    type: "mcqHelp",
    totalSteps: 3,
  },
  {
    label: "Assignment Help",
    sublabel: "Complete your assignments here",
    serviceType: "AssignmentHelp",
    type: "assignmentHelp",
    totalSteps: 4,
  },
  {
    label: "Live Session Help",
    sublabel: "Solve your questions instantly here",
    serviceType: "LiveSessionHelp",
    type: "livesessionHelp",
    totalSteps: 4,
  },
];

const assignmentHelpDefaultValue = {
  fontSize: "No",
  fontStyle: "No",
  lineSpacing: "No",
  referenceStyle: "No",
  haveReferenceFile: "No",
  deadline: 10,
};
const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const liveSessionDefaultValue = {
  haveReferenceFile: "No",
  date: `${new Date().getFullYear()}-${
    new Date().getMonth() < 10
      ? `0${new Date().getMonth() + 1}`
      : new Date().getMonth() + 1
  }-${
    new Date().getDate() < 9 ? `0${new Date().getDate()}` : new Date().getDate()
  }`,
  hours:
    new Date(new Date().setHours(new Date().getHours() + 4)).getHours() % 12 <
    10
      ? `0${
          new Date(new Date().setHours(new Date().getHours() + 4)).getHours() %
          12
        }`
      : new Date(new Date().setHours(new Date().getHours() + 4)).getHours() %
          12 || 12,
  minutes:
    new Date(new Date()).getMinutes() > 10
      ? new Date(new Date()).getMinutes()
      : `0${new Date(new Date()).getMinutes()}`,
  meradian: new Date(new Date()).getHours() < 12 ? "AM" : "PM",
  durationMintues: 60,
  timeZone: defaultTimezone,
};
const CommonForm = ({
  isOpen,
  toggle,
  typeData = "",
  subCategory = "",
  question,
  selectedSubject,
  selectedType,
}) => {
const location = useLocation();
const { pathname } = location;
 const { data, } = useSubSubjects();

  const [index, setIndex] = useState(1);
  const [nestedModal, setNestedModal] = useState(false);
  const [closeAll, setCloseAll] = useState(false);
  const [currentType, setCurrentType] = useState(typeData);
  const [isQuestionSubmited, setIsQuestionSubmited] = useState(false);
  const [error, setError] = useState({});
  const [isError, setIsError] = useState(false);
  const [payload, setPayload] = useState({
    subCategory: "",
    question: question || "",
    subject: selectedSubject?.value || "",
    questionType: selectedType?.value || "",
  });
  const [formData, setFormData] = useState({});
  const [rest, setRest] = useState({ setPayload });
  const [isPostButtonDisabled, setIsPostQuestionDisabled] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const quillfRef = useRef(null);
  const navigate = useNavigate();
  const toggleNested = () => {
    setNestedModal(!nestedModal);
    setCloseAll(false);
  };
  const [categorieData, setCategorieData] = useState([]);
  const fetchData = async () => {
    await getCategories()
      .then((data) => {
        const mergedArray = categoryStatic.map((obj1) => {
          const obj2 = data.data.find((obj) => obj.name === obj1.label);
          return { ...obj1, ...obj2 };
        });
        setCategorieData(mergedArray);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const closeBtn = (
    <button
      className="closBtn"
      onClick={toggleNested}
      style={{ zIndex: 1 }}
      type="button"
    >
      X
    </button>
  );

  const validateForm = (type, index, payload, extra = {}) => {
    let errors = {};
    if (type === "HomeworkHelp") {
      if (!payload.question) {
        errors.question = "Question is required!";
      }

      if (!payload.questionType) {
        errors.questionType = "Question Type is required!";
      }

      if (!payload.subject) {
        errors.subject = "Subject is required!";
      }
    }
    if (type === "AssignmentHelp") {
      if (!payload.subCategory) {
        errors.subCategory = "Assignment help is required!";
      }
      if (!payload.subject) {
        errors.subject = "Subject is required!";
      }
      if (
        (!payload?.questionPDF?.length || payload?.questionPDF?.length === 0) &&
        !payload?.question?.trim()?.length
      ) {
        errors.questionPDF = "Please add Question OR File!";
      }

      if (
        payload.haveReferenceFile === "Yes" &&
        !payload.referencePDF?.length
      ) {
        errors.referencePDF = "Please add Reference File!";
      }
    }
    if (type === "LiveSessionHelp") {
      if (index === 1 && !payload.subCategory) {
        errors.subCategory = "Select Any one Service";
      }

      if (index === 2) {
        if (
          (!payload?.questionPDF?.length ||
            payload?.questionPDF?.length === 0) &&
          !payload?.question?.trim()?.length
        ) {
          errors.questionPDF = "Please add Question OR File!";
        }

        if (
          payload.haveReferenceFile === "Yes" &&
          !payload.referencePDF?.length
        ) {
          errors.referencePDF = "Please add Reference File!";
        }

        if (!payload.subject) {
          errors.subject = "Please Select Subject";
        }
      }
    }
    return errors;
  };

  const continueButton = () => {
    setPayload((prevstate) => ({
      ...prevstate,
      categoryId: "65524e633c005ef3b51907c9",
    }));
    localStorage.setItem("serviceType", currentType.serviceType);
    if (currentType.serviceType === "LiveSessionHelp") {
      if (index === 1) {
        let isValid = true;

        if (!payload.subject) {
          setIsError(true);
          setError((prev) => ({
            ...prev,
            subject: "Subject is required!",
          }));
          isValid = false;
        } else {
          setError((prev) => ({ ...prev, subject: "" }));
        }

        if (!payload.subCategory) {
          setIsError(true);
          setError((prev) => ({
            ...prev,
            subCategory: "Live Session is required!",
          }));
          isValid = false;
        } else {
          setError((prev) => ({ ...prev, subCategory: "" }));
        }

        const hasQuestion = payload?.question?.trim()?.length > 0;
        if (!hasQuestion) {
          setIsError(true);
          setError((prev) => ({
            ...prev,
            question: "Question is required!",
          }));
          isValid = false;
        } else {
          setError((prev) => ({ ...prev, question: "" }));
        }
        if (isValid) {
          setIndex((prevIndex) => prevIndex + 1);
          // setIndex((prev) => prev + 1);
          setIsError(false);
        }
      } else if (index === 2) {
        let isValid = { question: true, reference: true, subject: true };
        if (
          (payload?.questionPDF?.length ? payload?.questionPDF?.length : 0) ===
            0 &&
          !payload?.question?.trim()?.length
        ) {
          setIsError(true);
          setError((prevstate) => ({
            ...prevstate,
            questionPDF: "Please add Question OR File!",
          }));
          isValid.question = false;
        } else {
          setError((prevstate) => ({
            ...prevstate,
            questionPDF: "",
          }));
          isValid.question = true;
        }

        if (
          payload.haveReferenceFile === "Yes" &&
          !payload.referencePDF?.length
        ) {
          setIsError(true);
          setError((prevstate) => ({
            ...prevstate,
            referencePDF: "Please add Reference File!",
          }));
          isValid.reference = false;
        } else {
          setError((prevstate) => ({
            ...prevstate,
            referencePDF: "",
          }));
          isValid.reference = true;
        }
        if (!payload.subject) {
          setIsError(true);
          setError((prevstate) => ({
            ...prevstate,
            subject: "Please Select Subject",
          }));
          isValid.subject = false;
        } else {
          setError((prevstate) => ({
            ...prevstate,
            subject: "",
          }));
          isValid.subject = true;
        }
        if (isValid.question && isValid.reference && isValid.subject) {
          setIndex((prevIndex) => prevIndex + 1);
          setIsError(false);
        }
      } else {
        if (index <= currentType.totalSteps - 1) {
          setIndex((prevIndex) => prevIndex + 1);
          setIsError(false);
        }
      }
    }
  };

  const backButton = () => {
    if (index > 1) {
      setIndex((prevIndex) => prevIndex - 1);
      setIsError(false);
    }
  };

  const handleChange = async (event) => {
    if (currentType.serviceType === "HomeworkHelp") {
      const { name, value, files } = event.target;
      if (files && files[0]) {
        const data = await handleUploadFile(Array.from(files), name);
        setPayload((prev) => ({
          ...prev,
          [name]: data,
        }));
        setError((prev) => ({
          ...prev,
          [name]: "",
        }));

        return;
      }
      setPayload((prev) => ({
        ...prev,
        [name]: value,
      }));
      setError((prev) => ({
        ...prev,
        [name]: !value || value.trim() === "" ? `${name} is required` : "",
      }));
    } else if (currentType.serviceType === "AssignmentHelp") {
      const { name, value, files, categoryId } = event.target;

      if (name === "subCategory") {
        setPayload((prev) => ({
          ...prev,
          subCategory: value,
          categoryId: categoryId,
        }));

        setError((prev) => ({
          ...prev,
          subCategory: !value ? "subCategory is required" : "",
        }));

        return;
      }

      if (event.target?.files && event.target?.files[0]) {
        const data = await handleUploadFile(
          Array.prototype.slice.call(event.target?.files),
          event.target.name,
        );

        setPayload((prevstate) => ({
          ...prevstate,
          [event.target.name]: data,
        }));
      } else if (event.target.name === "noOfWords") {
        const { value } = event.target;
        if (value === "" || parseInt(value) === 0) {
          setIsError(true);
          setError((prevstate) => ({
            ...prevstate,
            [event.target.name]: "Number must be greater than 0",
          }));
          setPayload((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value,
          }));
        } else if (
          /^\d+$/.test(value) &&
          parseInt(value) >= payload.min &&
          parseInt(value) < payload.max
        ) {
          setPayload((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value,
          }));
          setIsError(false);
          setError((prevstate) => ({
            ...prevstate,
            [event.target.name]: "",
          }));
        }
      } else {
        setPayload((prevstate) => ({
          ...prevstate,
          [event.target.name]: event.target?.value,
        }));
        if (event.target.value) {
          setIsError(false);
          setError((prevstate) => ({ ...prevstate, [event.target.name]: "" }));
        }
      }
    } else if (currentType.serviceType === "LiveSessionHelp") {
      if (event.target?.files && event.target?.files[0]) {
        const data = await handleUploadFile(
          Array.prototype.slice.call(event.target?.files),
          event.target.name,
        );
        setPayload((prevstate) => ({
          ...prevstate,
          [event.target.name]: data,
        }));
      } else if (event.target.name === "date") {
        const rawDate = event.target.value;

        if (!rawDate) return;

        const year = rawDate.getFullYear();
        const month = String(rawDate.getMonth() + 1).padStart(2, "0");
        const day = String(rawDate.getDate()).padStart(2, "0");

        const dateData = `${year}-${month}-${day}`;

        setPayload((prev) => ({
          ...prev,
          date: dateData,
        }));
      } else if (event.target.name === "hours") {
        const value = event.target.value;
        if (value === "") {
          setPayload((prev) => ({
            ...prev,
            hours: "",
          }));
          return;
        }

        if (/^\d{0,2}$/.test(value)) {
          setPayload((prev) => ({
            ...prev,
            hours: value,
          }));
        }
      } else if (event.target.name === "minutes") {
        const value = event.target.value;
        if (value === "") {
          setPayload((prev) => ({
            ...prev,
            minutes: "",
          }));
          return;
        }

        // allow only 2 digits
        if (/^\d{0,2}$/.test(value)) {
          const num = Number(value);

          if (!isNaN(num) && num >= 0 && num <= 59) {
            setPayload((prev) => ({
              ...prev,
              minutes: value,
            }));
          }
        }
      } else if (event.target.name === "durationMintues") {
        const { value } = event.target;
        if (value === "" || value === 0) {
          setIsError(true);
          setError((prevstate) => ({
            ...prevstate,
            [event.target.name]: "Minutes must be greater than 1",
          }));
          setPayload((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value,
          }));
        } else if (
          parseInt(event.target.value) >= 0 &&
          parseInt(event.target.value) <= 2000
        ) {
          setPayload((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value,
          }));
          setIsError(false);
          setError((prevstate) => ({
            ...prevstate,
            [event.target.name]: "",
          }));
        }
      } else {
        setPayload((prevstate) => ({
          ...prevstate,
          [event.target.name]: event.target.value,
        }));
        if (event.target.value) {
          setIsError(false);
          setError((prevstate) => ({ ...prevstate, [event.target.name]: "" }));
        }
      }
    }
  };

  const handlePostQuestion = async () => {
    if (isSubmitting) return;
    try {
      setIsSubmitting(true);
      if (currentType.serviceType === "HomeworkHelp") {
        const errors = validateForm(currentType.serviceType, index, payload, {
          question,
          selectedSubject,
          selectedType,
        });
        if (Object.keys(errors).length > 0) {
          setError(errors);
          setIsError(true);
          return;
        }

        const response = await createQuestionHomeworkHelp(payload);
        if (response.isSuccess) {
          if (localStorage.getItem("token")) {
            const updatedQuestion = await updateHomeworkHelpQuestion(
              response.question._id,
              {},
            );
            if (updatedQuestion.isSuccess) {
              localStorage.removeItem("questionId");
              // navigate(`/orderStatus/${response.question._id}`);
              navigate(`/dashboard/orderStatus/${response.question._id}`);
            }
          }
          setIsQuestionSubmited(true);
          localStorage.setItem("questionId", response.question._id);
          localStorage.setItem("serviceType", currentType.serviceType);
        }
      } else if (currentType.serviceType === "AssignmentHelp") {
        const errors = validateForm(currentType.serviceType, index, payload, {
          question,
          selectedSubject,
          selectedType,
        });

        if (Object.keys(errors).length > 0) {
          setError(errors);
          setIsError(true);
          return;
        }

        const response = await createQuestionAssignmentHelp(payload);
        if (response.isSuccess) {
          if (localStorage.getItem("token")) {
            const updatedQuestion = await updateAssignmentQuestion(
              response.question._id,
              {},
            );
            if (updatedQuestion.isSuccess) {
              localStorage.removeItem("questionId");
            }
            // navigate(`/orderStatus/${response.question._id}`);
            navigate(`/dashboard/orderStatus/${response.question._id}`);
          } else {
            setIsQuestionSubmited(true);
            localStorage.setItem("questionId", response.question._id);
            localStorage.setItem("serviceType", currentType.serviceType);
          }
        }
      } else if (currentType.serviceType === "LiveSessionHelp") {
        const response = await createQuestionLivesessionHelp(payload);
        if (response.isSuccess) {
          if (localStorage.getItem("token")) {
            const updatedQuestion = await updateLiveSessionQuestion(
              response.question._id,
              {
                discountPrice: 0,
                promoPrice: 0,
                promoCode: "",
              },
            );
            if (updatedQuestion.isSuccess) {
              localStorage.removeItem("questionId");
            }
            // navigate(`/orderStatus/${response.question._id}`);
            navigate(`/dashboard/orderStatus/${response.question._id}`);
          }
          setIsQuestionSubmited(true);
          localStorage.setItem("questionId", response.question._id);
          localStorage.setItem("serviceType", currentType.serviceType);
        }
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePopupType = (serviceType, type, totalSteps) => {
    setCurrentType({ serviceType, type, totalSteps });
    localStorage.setItem("serviceType", serviceType);
  };

  const fetchHomeworkCategory = async () => {
    const response = await getCategoryWiseSubcategory(
      "65524e5e3c005ef3b51907c6",
    );

    const activeSubcategory = response.subCategory?.filter((x) => x.isActive);
    const tempData = activeSubcategory?.map((x) => ({
      _id: x?._id,
      name: x?.name,
      image: x?.image,
      url: x?.path,
    }));
    setFormData((prevstate) => ({ ...prevstate, subcategory: tempData }));
    return response;
  };


  const fetchCategories = async (categoryId) => {
    await getCategoryWiseSubcategory(categoryId)
      .then((data) => {
        setRest((prevState) => ({
          ...prevState,
          categories: data.subCategory,
        }));
      })
      .catch((err) => console.log(err));
  };

  const fetchQuestionPricingData = async (id) => {
    const response = await getSubcategoryWisePrice(id);
    setPayload((prevstate) => ({
      ...prevstate,
      price: response?.price?.studentPrice,
    }));
  };

  const handleUploadFile = async (files, name) => {
    const uploaded = payload[name] ? [...payload[name]] : [];

    files.some((file) => {
      if (uploaded.findIndex((f) => f.name === file.name) === -1) {
        uploaded.push(file);
      }
    });
    if (uploaded.length === 0) {
      setIsError(true);
    } else {
      setIsError(false);
    }
    return uploaded;
  };

  const handleRemoveFile = (index, key) => {
    const payloadClone = payload;
    if (payloadClone[key]) {
      payloadClone[key]?.splice(index, 1);
    }
    setPayload({ ...payloadClone });
  };



 

  const getLiveSessionPrice = async () => {
    setIsPostQuestionDisabled(true);
    const response = await getPriceLivehelp({
      durationMintues: payload.durationMintues,
    });
    if (response.isSuccess) {
      setFormData((prevstate) => ({
        ...prevstate,
        studentPrice: response?.price?.studentPrice,
      }));
    }
    setTimeout(() => {
      setIsPostQuestionDisabled(false);
    }, 100);
  };

  useEffect(() => {
    if (currentType.serviceType === "HomeworkHelp") {
      fetchHomeworkCategory();
    } else if (currentType.serviceType === "AssignmentHelp") {
      fetchCategories("65524e633c005ef3b51907c9");
      setPayload({ ...payload, ...assignmentHelpDefaultValue });
      setRest({ ...rest, handleRemoveFile });
    } else if (currentType.serviceType === "LiveSessionHelp") {
      fetchCategories("65524e353c005ef3b51907c2");
      setPayload({ ...payload, ...liveSessionDefaultValue });
    }
    if(data?.data?.length){
      setFormData((prevstate) => ({ ...prevstate, subject: data?.data }));
    }
  }, [currentType]);

  useEffect(() => {
    if (payload.questionType) {
      fetchQuestionPricingData(payload.questionType);
    }
  }, [payload.questionType]);

 

  useEffect(() => {
    setRest({ ...rest, handleRemoveFile });
  }, [payload]);

  
  useEffect(() => {
    if (payload.durationMintues) {
      getLiveSessionPrice();
    }
  }, [payload.durationMintues]);

  const allowedTypes = ["AssignmentHelp", "LiveSessionHelp", "HomeworkHelp"];

  const isNormalSize = allowedTypes.includes(currentType?.serviceType);
  const isFullScreen = isQuestionSubmited || !isNormalSize;
  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        centered
        size={!isFullScreen ? "lg" : undefined}
        fullscreen={isFullScreen}
      >
        {isQuestionSubmited ? <div className="authentication-bg"></div> : null}
        <ModalHeader close={closeBtn} className="border-0"></ModalHeader>
        <ModalBody>
          <Col className="mx-auto pop-width" xs="12" md="12">
            {!currentType ? (
              <div className="d-flex flex-column">
                <div className="mainHeading">
                  Types of Academic help you need.
                </div>
                <div className="d-flex row mt-5 g-3">
                  {categorieData.map((category) => {
                    return (
                      category.isActive === true && (
                        <div className="col category-card p-5 d-flex rounded-3  flex-column align-items-center justify-content-between">
                          <div>
                            <img
                              src={ImageLink(category.icon)}
                              alt="Icon"
                              className="w-50"
                            />
                          </div>
                          <div className="category-label">{category.name}</div>
                          <div className="category-sublabel mb-2">
                            {category.description}
                          </div>
                          <Button
                            className="mb-3"
                            text={"Continue"}
                            onClick={() =>
                              handlePopupType(
                                category.serviceType,
                                category.type,
                                category.totalSteps,
                              )
                            }
                          />
                        </div>
                      )
                    );
                  })}
                </div>
              </div>
            ) : (
              <>
                {!isQuestionSubmited ? (
                  <>
                    {/* {
                    currentType.totalSteps > 1 && (
                    <Row className="m-5">
                      <Col className="align-self-center">
                        <MultiStepProgressBar
                          step={index}
                          totalSteps={currentType.totalSteps}
                        />
                      </Col>
                    </Row>
                  )} */}
                    <Row>
                      {FormUI(
                        currentType?.type,
                        index,
                        payload,
                        handleChange,
                        formData,
                        rest,
                        quillfRef,
                        error,
                        isError,
                        setIsError,
                        question,
                        selectedType,
                        selectedSubject,
                        currentType.totalSteps,
                        pathname,
                      )}
                    </Row>
                    <Row className="mt-3">
                      <Col className="d-flex justify-content-center gap-5">
                        {currentType.serviceType === "LiveSessionHelp" &&
                          index == 3 && (
                            <Button
                              varient="outline-secondaty"
                              text="Back"
                              onClick={backButton}
                              disabled={index == 1}
                            />
                          )}

                        {index !== currentType.totalSteps ? (
                          <Button
                            varient="linear-gradient-primary"
                            text="Continue"
                            onClick={continueButton}
                            disabled={isError || isPostButtonDisabled}
                          />
                        ) : (
                          <SubmitButton
                            varient="linear-gradient-primary"
                            text="Continue"
                            onClick={handlePostQuestion}
                            disabled={isSubmitting}
                            loading={isSubmitting}
                          />
                        )}
                      </Col>

                      {currentType?.type === "mcqHelp" && (
                        <div className="d-flex flex-column align-items-center text-center">
                          <h2 className="step-sub-header">How it works</h2>
                          <Row className="justify-content-center w-100">
                            <Col
                              md={10}
                              className="d-flex flex-column flex-md-row gap-2 gap-md-4 justify-content-center align-items-center"
                            >
                              <FormGroup className="d-flex align-items-center gap-2 flex-nowrap">
                                <img src={checkLogo} height="20" width="20" />
                                <Label className="form-label m-0 text-nowrap">
                                  Post one question at one time
                                </Label>
                              </FormGroup>

                              <FormGroup className="d-flex align-items-center gap-0 gap-md-2 flex-nowrap">
                                <img src={checkLogo} height="20" width="20" />
                                <Label className="form-label m-0 text-nowrap">
                                  Get an instant answer from our experts
                                </Label>
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                      )}
                      {(currentType?.type === "livesessionHelp" ||
                        currentType?.type === "assignmentHelp") && (
                        <p className="text-center leading-6 form-label mt-4">
                          Apply reward points to get extra 10% of wallet <br />
                          Pay full using TBCredit & Save additional 5%.
                        </p>
                      )}
                    </Row>
                  </>
                ) : (
                  <Authentication key={"signin"} />
                )}
              </>
            )}
           <Modal
  isOpen={nestedModal}
  toggle={toggleNested}
  centered
  className="confirm-modal"
  onClosed={closeAll ? toggle : undefined}
>
  <ModalBody>
    <div className="confirm-container">

     <div className="confirm-icon gradient-icon">
  <FiAlertTriangle />
</div>

      <h5 className="confirm-title mb-2">
        Leave this window?
      </h5>
      <p className="confirm-text">
        Are you sure you want to leave this window? Your progress may not be saved.
      </p>
      <div className="confirm-actions">
  <button
    className="button button-primary"
    onClick={toggleNested}
  >
    Resume
  </button>

  <button
    className="button button-danger"
    onClick={toggle}
  >
    Exit
  </button>
</div>

    </div>
  </ModalBody>
</Modal>
            {/* <Modal
              isOpen={nestedModal}
              toggle={toggleNested}
              centered
              className="rounded-5 rounded"
              onClosed={closeAll ? toggle : undefined}
            >
              <ModalBody>
                <div className="p-5">
                  <div className="nestedPopup">
                    Are you sure you want to leave this window?
                  </div>
                  <div className="pt-3 d-flex justify-content-end">
                    <span className="pe-3 resumeBtn" onClick={toggleNested}>
                      Resume
                    </span>
                    <span className="ps-3 exitBtn" onClick={toggle}>
                      Exit
                    </span>
                  </div>
                </div>
              </ModalBody>
            </Modal> */}
          </Col>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CommonForm;
